"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameCenterAssetUrl = void 0;
function getGameCenterAssetUrl(fileName) {
    return `https://prod-cdn.flarie.com/asset/game-center/${fileName}`;
}
exports.getGameCenterAssetUrl = getGameCenterAssetUrl;
